import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_DELETE_REQUIRED_DOCUMET,
  SUCCESS_DELETE_REQUIRED_DOCUMET,
  FAILURE_DELETE_REQUIRED_DOCUMET,
} = documentationActions;

function* deleteRequiredDocument(action: any): SagaReturnType<any> {
  try {
    const response = yield call(templateService.deleteRequireddocument, action.documentUuid);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_DELETE_REQUIRED_DOCUMET, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_DELETE_REQUIRED_DOCUMET, payload: error });
  }
}

function* deleteRequiredDocSaga() {
  yield takeEvery(REQUEST_DELETE_REQUIRED_DOCUMET, deleteRequiredDocument);
}

export default deleteRequiredDocSaga;
